import { createFileRoute } from "@tanstack/react-router";

import { SystemStatusPage } from "@/modules/system-status/system-status-page";

export const Route = createFileRoute("/(app)/_main-layout/system-status")({
  component: SystemStatusPage,
});
